import React from 'react';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';


import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';


import { GridContainer } from '../../global';
import { YellowButton } from '../shared/YellowButton';
import {
  TwoColumnLayout,
  TextContainer,
  ImageContainer,
  ButtonsContainer,
  ManImage,
  PanelImageBackground,
  CourseDiagramImage,
  SlideContainer 
} from './style';


import manImage from './Homen.png';
import backgroundImage from './FundoHomen.png';
import courseImage from './DiagramaCurso.png';

const HeroCarousel = () => {

  const whatsappNumber = '5519996514827'; 
  const whatsappLink = `https://wa.me/${whatsappNumber}`;
  return (
    <Swiper
   
      modules={[Navigation, Pagination, Autoplay]}
      slidesPerView={1} 
      spaceBetween={30} 
      loop={true} 
      pagination={{ clickable: true }} 
      navigation
      autoplay={{
        delay: 5000,
        disableOnInteraction: false,
      }}
    >
    
      <SwiperSlide>

        <SlideContainer>
          <GridContainer>
            <TwoColumnLayout>
              <TextContainer>
                <h1>RENOVAÇÃO EM ENERGIA SOLAR</h1>
                <p>
                  Na Renovera, você garante o melhor preço em equipamentos fotovoltaicos,
                  com atendimento humanizado e uma compra simples e ágil. 
                  Para projetos com homologação indeferida por Inversão de Fluxo de Potência, conte com nossa consultoria exclusiva do Renô Adviser.
                </p>
                <ButtonsContainer>
                  <YellowButton href={whatsappLink} target="_blank" rel="noopener noreferrer">
                 <img src="/icone/icone-whatsapp.png" alt="Ícone do WhatsApp" />
                   MELHOR PREÇO EM EQUIPAMENTOS
                  </YellowButton>
                  <YellowButton href="https://integrador.renovera.com.br/reno-adviser">RENÔ ADVISER</YellowButton>
                </ButtonsContainer>
              </TextContainer>
              
              <ImageContainer>
                <PanelImageBackground src={backgroundImage} alt="" />
                <ManImage src={manImage} alt="Especialista em Energia Solar Renovera" />
              </ImageContainer>
            </TwoColumnLayout>
          </GridContainer>
        </SlideContainer>
      </SwiperSlide>
      
 {/*
      <SwiperSlide>
        <SlideContainer>
          <GridContainer>
            <TwoColumnLayout>
              <TextContainer>
                <h1>CAPACITE-SE CONTRA A INVERSÃO DE FLUXO</h1>
                <p>
                  Nosso novo curso oferece o conhecimento técnico-jurídico para você dominar as complexidades da Inversão de Fluxo de Potência. Prepare-se para reverter negativas e garantir a aprovação dos seus projetos.
                </p>
                <ButtonsContainer>
                  
                  <YellowButton href="/curso">
                    SAIBA MAIS SOBRE O CURSO
                  </YellowButton>
                  <YellowButton href={whatsappLink} target="_blank" rel="noopener noreferrer">FALAR COM UM ESPECIALISTA</YellowButton>
                </ButtonsContainer>
              </TextContainer>
              
              <ImageContainer>
              
                <CourseDiagramImage src={courseImage} alt="" />
              </ImageContainer>
            </TwoColumnLayout>
          </GridContainer>
        </SlideContainer>
      </SwiperSlide>
      */}
    </Swiper>
  );
};

export default HeroCarousel;